import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { GetFeatureParameterDataType, FeatureParameterDataType, SelectDataType } from './FeatureParameter';
import dayjs from 'dayjs';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { SpeedKind } from '../../../Constant';

const useStyles = makeStyles(
  createStyles({
    //テーブル外枠
    tableStyle: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
    },
    //テーブルヘッダセル
    tableHeaderCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      minWidth: '80px',
      padding: '1px',
      height: '50px',
      borderCollapse: 'collapse',
    },
    //テーブルボディーセル
    tableCell: {
      borderWidth: '1px',
      borderLeftStyle: 'solid',
      borderBottomStyle: 'inset',
      padding: '0px',
      minWidth: '80px',
      borderColor: '#dcdcdc',
      textAlign: 'right',
    },
    //テーブルボディー日付セル
    tableDateCell: {
      borderWidth: '1px',
      borderLeftStyle: 'solid',
      borderBottomStyle: 'inset',
      padding: '0px',
      paddingRight: '4px',
      minWidth: '80px',
      borderColor: '#dcdcdc',
      textAlign: 'right',
    },
    // tableHeader: {
    //   borderWidth: '1px',
    //   padding: '0px',
    //   borderStyle: 'inset',
    //   borderCollapse: 'collapse',
    //   borderColor: '#dcdcdc',
    // },
  })
);

export type RefreshGridDataType = {
  selectDataType: SelectDataType;
};

type BodyDataProps = {
  fpData: FeatureParameterDataType;
  index: number;
};

type Props = {
  tableContainerStyle: string;
  refreshGridData: RefreshGridDataType;
  updateLoadginState: (value: boolean) => void;
};

type rowData = {
  day: string[];
  fData: FeatureParameterDataType[];
};

const FeatureParameterGrid: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [featureParameter, setFeatureParameterList] = React.useState<FeatureParameterDataType[]>([]);
  const [selectData, setSelectData] = React.useState<SelectDataType>({
    mesid: 0,
    devIndex: 0,
    year: 2021,
    month: 1,
  });
  const [dayList, setDayList] = React.useState<rowData>();

  // 四捨五入
  const roundDecimal = (value: string, n: number): string => {
    var num = Number(value);
    var ans = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);

    return value === '' ? '' : String(ans);
  };

  const HeaderData: React.FC<FeatureParameterDataType> = (props) => {
    if (props.Datas.length === 1) {
      return (
        <Table aria-label="featureParameter">
          <TableRow>
            <TableCell className={classes.tableHeaderCell}>
              {props.DeviceInfo.MesName + ' ' + props.DeviceInfo.ItemName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.瞬時値', '瞬時値')}</TableCell>
          </TableRow>
        </Table>
      );
    } else if (props.Datas.length === 3) {
      if (props.Datas[0].ItemSpeed === SpeedKind.SPEED_CONAN) {
        return (
          <Table aria-label="featureParameter">
            <TableRow>
              <TableCell colSpan={3} className={classes.tableHeaderCell}>
                {props.DeviceInfo.MesName + ' ' + props.DeviceInfo.ItemName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHeaderCell}>
                {t('FeatureParameterGrid.振動最大値', '最大値')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('FeatureParameterGrid.振動実行値', '実行値')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.振動速度', '速度')}</TableCell>
            </TableRow>
          </Table>
        );
      } else {
        return (
          <Table aria-label="featureParameter">
            <TableRow>
              <TableCell colSpan={3} className={classes.tableHeaderCell}>
                {props.DeviceInfo.MesName + ' ' + props.DeviceInfo.ItemName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHeaderCell}>
                {t('FeatureParameterGrid.電流最大値', '最大値')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('FeatureParameterGrid.電流実行値', '実行値')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.電流OA値', 'OA値')}</TableCell>
            </TableRow>
          </Table>
        );
      }
      console.debug(['props.Datas', props.Datas]);
    } else if (props.Datas.length === 5) {
      return (
        <Table aria-label="featureParameter">
          <TableRow>
            <TableCell colSpan={5} className={classes.tableHeaderCell}>
              {props.DeviceInfo.MesName + ' ' + props.DeviceInfo.ItemName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.振動最大値', '最大値')}</TableCell>
            <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.振動実行値', '実行値')}</TableCell>
            <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.振動OA値', 'OA値')}</TableCell>
            <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.振動速度', '速度')}</TableCell>
            <TableCell className={classes.tableHeaderCell}>{t('FeatureParameterGrid.振動変位', '変位')}</TableCell>
          </TableRow>
        </Table>
      );
    } else {
      return <div></div>;
    }
  };

  const BodyData: React.FC<BodyDataProps> = (props) => {
    //判定値
    const judgementValue = (n: number): string => {
      return n === 0 ? '[]' : `[${String(n)}]`;
    };
    /**
     * 判定スタイル
     * @returns
     */
    const judgementColorStyle = (sate: number): { color: string; background: string } => {
      if (sate == undefined) return { color: 'black', background: 'white' };

      /*
      3:重故障
      2:軽故障
      1:復帰
      0:正常　実際、正常は登録されないため、
      */

      switch (sate) {
        case 0: //正常
          return { color: 'black', background: 'white' };
        case 1: //復帰
          return { color: 'white', background: 'Green' };
        case 2: //軽故障
          return { color: 'black', background: 'yellow' };
        case 3: //重故障
          return { color: 'white', background: 'red' };
        default:
          //不明
          return { color: 'black', background: 'white' };
      }
    };

    /**
     * 値表示セル
     * @returns
     */
    const body_value_cell_disp = (p: BodyDataProps, dataIndex: number) => {
      return (
        <TableCell className={classes.tableCell}>
          <div
            style={{
              ...judgementColorStyle(p.fpData.Datas[dataIndex].FeatureParameterDatas[p.index].Judgement),
            }}
          >
            {roundDecimal(p.fpData.Datas[dataIndex].FeatureParameterDatas[p.index].Value, 4)}&nbsp;
          </div>
        </TableCell>
      );
    };

    if (props.index > props.fpData.Datas[0].FeatureParameterDatas.length) {
      return <div></div>;
    }
    if (props.fpData.Datas.length === 1) {
      return (
        <Table aria-label="featureParameter">
          <TableRow>{body_value_cell_disp(props, 0)}</TableRow>
        </Table>
      );
    } else if (props.fpData.Datas.length === 3) {
      return (
        <Table aria-label="featureParameter">
          <TableRow>
            {body_value_cell_disp(props, 0)}
            {body_value_cell_disp(props, 1)}
            {body_value_cell_disp(props, 2)}
          </TableRow>
        </Table>
      );
    } else if (props.fpData.Datas.length === 5) {
      return (
        <Table aria-label="featureParameter">
          <TableRow>
            {body_value_cell_disp(props, 0)}
            {body_value_cell_disp(props, 1)}
            {body_value_cell_disp(props, 2)}
            {body_value_cell_disp(props, 3)}
            {body_value_cell_disp(props, 4)}
          </TableRow>
        </Table>
      );
    } else {
      return <div></div>;
    }
  };

  //表示ボタン押下時
  useEffect(() => {
    props.updateLoadginState(true);
    var selectData = props.refreshGridData.selectDataType;
    // 月は 0 起点
    var time = dayjs(new Date(selectData.year, selectData.month - 1, 1, 0, 0, 0)).toDate();
    GetFeatureParameterDataType(selectData.devIndex, time).then((ret) => {
      var dList: string[] = [];
      if (ret.length !== 0) {
        for (var i in ret[0].Datas[0].FeatureParameterDatas) {
          dList.push(dayjs(ret[0].Datas[0].FeatureParameterDatas[i].Day).format('MM/DD'));
        }
      }

      console.debug(['表示ボタン押下', ret]);
      var rowDt: rowData = {
        day: dList,
        fData: ret,
      };
      setDayList(rowDt);
      setFeatureParameterList(ret);
      setSelectData({ ...selectData });
      props.updateLoadginState(false);
    });
  }, [props.refreshGridData]);

  //console.debug('画面描画開始 -- dayList:', dayList);
  return (
    <TableContainer component={Paper} className={props.tableContainerStyle}>
      <Table aria-label="featureParameter" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeaderCell}>
              {selectData?.year + t('FeatureParameterGrid.年', '年')}
            </TableCell>
            {featureParameter?.map((item, index) => (
              <TableCell className={classes.tableHeaderCell}>
                <HeaderData DeviceInfo={item.DeviceInfo} Datas={item.Datas}></HeaderData>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {dayList?.day?.map((item, index) => (
            <TableRow>
              <TableCell className={classes.tableDateCell}>{item}</TableCell>
              {dayList?.fData?.map((row2) => (
                <TableCell className={classes.tableCell}>
                  <BodyData fpData={row2} index={index}></BodyData>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FeatureParameterGrid;
